import firebase from 'firebase/compat/app'
import { ProductRebillingService } from './../services'
export const uploadPathEmailBuilder = (locationId: string, docId: string) => {
  return `email-builder/${locationId}/${docId}`
}

export const uploadJsonToStorage = async (path: string, data: object) => {
  try {
    const metaData = {
      name: path,
      contentDisposition: `inline; filename="${path}"`,
      contentType: 'application/json'
    }
    const uploadPath = firebase.storage().ref(path)
    const sectionData = JSON.stringify(data)
    const base64 = btoa(sectionData)
    const snapshot = await uploadPath.putString(base64, 'base64', metaData)
    const storageUrl = snapshot.ref.fullPath
    const downloadUrl = await snapshot.ref.getDownloadURL()
    return {
      storageUrl,
      downloadUrl
    }
  } catch (error) {
     
    console.error(error)
    return error
  }
}

const isLocationContentAIEnabled = async (locationId: string, companyId: string) => {
  const data = await ProductRebillingService.getByProductAndLocation(locationId, companyId, 'contentAI')
  if(data?.config?.optIn) return data?.config?.optIn
  return false
}
export const contentAiPermission = async (
  locationId: string,
  companyId: string,
  permissions: any
) => {
  try {
    const contentAiEnabled =
      permissions.content_ai_enabled === false ? false : true
    // TODO: @Anas Access this value from any stored variable instead of fetching (in future)
    const locationContentAIEnabled = await isLocationContentAIEnabled(locationId,companyId)
    return contentAiEnabled && locationContentAIEnabled
  } catch (error) {
     
    console.error(error)
    return error
  }
}